// A request may commit only in the session/location generation that started it.
export class StockRefreshGate {
  private sequence = 0;
  invalidate() { return ++this.sequence; }
  begin() { return this.invalidate(); }
  accepts(sequence: number) { return sequence === this.sequence; }
}

export const PENDING_CHECKOUT_KEY = "casa-hawa-pending-checkout-v1";
export interface PendingCheckout {
  userId: string;
  payload: Record<string, unknown>;
}
export function readPendingCheckout(storage: Pick<Storage, "getItem">): PendingCheckout | null {
  const raw = storage.getItem(PENDING_CHECKOUT_KEY);
  if (!raw) return null;
  const value = JSON.parse(raw) as PendingCheckout;
  if (!value.userId || !value.payload?.idempotencyKey) {
    throw new Error("Hay un cobro pendiente ilegible. No vuelvas a cobrar; solicita revisión.");
  }
  return value;
}

export function persistCheckout(storage: Pick<Storage, "getItem" | "setItem">, value: PendingCheckout) {
  const serialized = JSON.stringify(value);
  storage.setItem(PENDING_CHECKOUT_KEY, serialized);
  if (storage.getItem(PENDING_CHECKOUT_KEY) !== serialized) {
    throw new Error("No se pudo proteger el reintento del cobro. Revisa el almacenamiento del navegador.");
  }
}
